import { useMutation } from '@tanstack/react-query';
import { ApiError, post } from '@/lib/api/client';
import { useAuthStore } from './auth.store';
import { canAccessPortal } from './roles';
import type { LoginResponse } from './types';

export interface Credentials {
  email: string;
  password: string;
}

async function login({ email, password }: Credentials): Promise<LoginResponse> {
  const result = await post<LoginResponse>('oauth/local/login', {
    username: email,
    password,
  });

  // Authenticating and being allowed into the admin portal are different
  // questions; a consumer account gets a valid token and no portal access.
  if (!canAccessPortal(result.state?.profile?.roles)) {
    // An i18n key, not a sentence — the caller translates it. A message
    // relayed from the server passes through t() unchanged.
    throw new ApiError('auth.validation.notAuthorized');
  }

  return result;
}

export function useLogin() {
  const signIn = useAuthStore((s) => s.signIn);

  return useMutation({
    mutationFn: login,
    onSuccess: (data) => signIn(data),
  });
}
